import cx from "classnames"
import { AppContext } from "contexts/AppContext";
import { useContext } from "react";
import LogoVNF from "../assets/img/logo-vnf.svg";

export default function Footer() {
  const { isMobile } = useContext(AppContext);

  return (
    <footer
      className={cx("footer", {
        mobile: isMobile,
      })}
    >
      <span className="links">
        <a target="_blank" href={import.meta.env.REACT_APP_CONTACT_URL} rel="noreferrer">Contact</a>
        <span> | </span>
        <a target="_blank" href={import.meta.env.REACT_APP_COOKIE_URL} rel="noreferrer">Cookies</a>
        <span> | </span>
        <a target="_blank" href={import.meta.env.REACT_APP_LEGAL_URL} rel="noreferrer">Mentions légales</a>
      </span>
      <a
        className="footer-logo"
        href={import.meta.env.REACT_APP_VNF_WEBSITE_URL}
        target="_blank"
        rel="noreferrer"
        title="VNF"
      >
        <img src={LogoVNF} alt="logo" />
      </a>
    </footer>
  )
}
